<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12">
                <label>{{ trans('Ends') }}:</label>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-3 form-check mt-1">
                <input
                    v-model="repeatRangeType"
                    @change="emitValues"
                    :value="1"
                    :class="{ 'is-invalid': errors && errors[fieldPrefix + 'repeatRangeType'] }"
                    type="radio"
                    id="repeatRangeType"
                    name="repeatRangeType"
                    class="planning-form-check-input"
                />
                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatRangeType']"
                >
                    {{ errors[fieldPrefix + 'repeatRangeType'][0] }}
                </div>
                <label class="form-check-label" for="repeatUntil">{{ trans('On') }}</label>
            </div>
            <div class="col-9" v-if="repeatRangeType === 1">
                <vue-flatpickr
                    :modelValue="repeatUntil"
                    @update:modelValue="repeatUntil = $event"
                    :config="{
                        allowInput: true,
                        dateFormat: 'Y-m-d',
                        altInput: true,
                        altFormat: 'd/m/Y',
                        minDate: this.modelValue.dateStart,
                    }"
                    :class="{ 'is-invalid': errors && errors[fieldPrefix + 'repeatUntil'] }"
                    id="repeatUntil"
                    name="repeatUntil"
                    class="form-control"
                    autocomplete="off"
                >
                </vue-flatpickr>

                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatUntil']"
                >
                    {{ errors[fieldPrefix + 'repeatUntil'][0] }}
                </div>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-3 form-check mt-1">
                <input
                    v-model="repeatRangeType"
                    @change="emitValues"
                    :value="2"
                    :class="{ 'is-invalid': errors && errors[fieldPrefix + 'repeatRangeType'] }"
                    type="radio"
                    id="repeatRangeType_mode"
                    name="repeatRangeType"
                    class="planning-form-check-input"
                />
                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatRangeType']"
                >
                    {{ errors[fieldPrefix + 'repeatRangeType'][0] }}
                </div>
                <label class="form-check-label" for="repeatAfter">{{ trans('After') }}</label>
            </div>
            <div class="col-9" v-if="repeatRangeType === 2">
                <div class="input-group">
                    <input
                        name="repeatAfter"
                        id="repeatAfter"
                        class="form-control"
                        v-model.number="repeatAfter"
                        @change="emitValues"
                        required
                        min="1"
                        max="100"
                        step="1"
                        type="number"
                        :class="{
                            'is-invalid': errors && errors[fieldPrefix + 'repeatAfter'],
                        }"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text">{{ trans('occurrences') }}</span>
                    </div>
                </div>

                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatAfter']"
                >
                    {{ errors[fieldPrefix + 'repeatAfter'][0] }}
                </div>
            </div>
        </div>

        <div class="row form-group">
            <div class="col-12">
                <label class="form-control-label" for="repeatFrequency">{{
                    trans('Frequency')
                }}</label>

                <v-select
                    class="form-control"
                    :options="optionsOfRepeatFrequencies"
                    :reduce="(option) => option.id"
                    :modelValue="repeatFrequency"
                    @update:modelValue="repeatFrequency = $event"
                    :class="{
                        'is-invalid': errors && errors[fieldPrefix + 'repeatFrequency'],
                    }"
                ></v-select>

                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatFrequency']"
                >
                    {{ errors[fieldPrefix + 'repeatFrequency'][0] }}
                </div>
            </div>
        </div>

        <div class="row" v-if="repeatFrequency === 6">
            <div class="col-6 form-group">
                <label class="form-control-label" for="repeatEvery">{{ trans('Every') }}</label>

                <div class="input-group">
                    <input
                        name="repeatEvery"
                        id="repeatEvery"
                        class="form-control"
                        v-model.number="repeatEvery"
                        @change="emitValues"
                        required
                        min="1"
                        max="100"
                        step="1"
                        type="number"
                        :class="{
                            'is-invalid': errors && errors[fieldPrefix + 'repeatEvery'],
                        }"
                    />
                </div>
                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatEvery']"
                >
                    {{ errors[fieldPrefix + 'repeatEvery'][0] }}
                </div>
            </div>

            <div class="col-6">
                <label class="form-control-label">&nbsp;</label>

                <v-select
                    class="form-control"
                    :options="repeatEveryTypeList"
                    :reduce="(option) => option.id"
                    :modelValue="repeatEveryType"
                    @update:modelValue="repeatEveryType = $event"
                    :class="{
                        'is-invalid': errors && errors[fieldPrefix + 'repeatEveryType'],
                    }"
                ></v-select>

                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatEveryType']"
                >
                    {{ errors[fieldPrefix + 'repeatEveryType'][0] }}
                </div>
            </div>

            <div class="col-12 form-group" v-show="repeatEveryType === 2">
                <label class="form-control-label" for="repeatOn_week">{{ trans('On') }}</label>

                <v-select
                    class="form-control"
                    :modelValue="repeatOn"
                    @update:modelValue="repeatOn = $event"
                    :reduce="(option) => option.id"
                    :options="repeatOnListWeek"
                    :multiple="true"
                    :class="{
                        'is-invalid': errors && errors[fieldPrefix + 'repeatOn'],
                    }"
                ></v-select>
                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatOn']"
                >
                    {{ errors[fieldPrefix + 'repeatOn'][0] }}
                </div>
            </div>

            <div class="col-12 form-group" v-show="repeatEveryType === 3">
                <label class="form-control-label" for="repeatOnMonth">{{ trans('On') }}</label>

                <v-select
                    class="form-control"
                    :modelValue="repeatOnEveryMonth"
                    @update:modelValue="repeatOnEveryMonth = $event"
                    :reduce="(option) => option.id"
                    :options="optionsOnListMonth"
                    :class="{
                        'is-invalid': errors && errors[fieldPrefix + 'repeatOnEveryMonth'],
                    }"
                ></v-select>
                <div
                    class="invalid-feedback d-block"
                    v-if="errors && errors[fieldPrefix + 'repeatOnEveryMonth']"
                >
                    {{ errors[fieldPrefix + 'repeatOnEveryMonth'][0] }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueFlatpickr from 'vue-flatpickr-component';
import { convert, IsoFields, LocalDate } from '@js-joda/core';

export default {
    components: {
        VueFlatpickr,
    },
    props: {
        dateStart: {
            required: true,
        },
        modelValue: {
            required: true,
            type: Object,
        },
        errors: {
            required: false,
            type: Object,
        },
        fieldPrefix: {
            required: false,
            type: String,
            default: 'timings.',
        },
    },
    data() {
        return {
            // Repeat timings
            repeatRangeType: this.modelValue.repeatRangeType,
            repeatUntil: this.modelValue.repeatUntil,
            repeatAfter: this.modelValue.repeatAfter,
            repeatFrequency: this.modelValue.repeatFrequency,
            repeatEvery: this.modelValue.repeatEvery,
            repeatEveryType: this.modelValue.repeatEveryType,
            repeatOn: this.modelValue.repeatOn,
            repeatOnEveryMonth: this.modelValue.repeatOnEveryMonth,

            // Configs
            dateConfig: {
                allowInput: true,
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd/m/Y',
            },
            repeatEveryTypeList: [
                { id: 1, label: trans('Day') },
                { id: 2, label: trans('Week') },
                { id: 3, label: trans('Month') },
                { id: 4, label: trans('Year') },
            ],
            repeatOnListWeek: [
                { id: 1, label: trans('Monday') },
                { id: 2, label: trans('Tuesday') },
                { id: 3, label: trans('Wednesday') },
                { id: 4, label: trans('Thursday') },
                { id: 5, label: trans('Friday') },
                { id: 6, label: trans('Saturday') },
                { id: 7, label: trans('Sunday') },
            ],
        };
    },
    computed: {
        watchedFields(){
            return [
                this.repeatUntil,
                this.repeatFrequency,
                this.repeatEvery,
                this.repeatEveryType,
                this.repeatOn,
                this.repeatOnEveryMonth,
            ];
        },
        optionsOfRepeatFrequencies() {
            let dateStart = this.dateStart;
            dateStart = LocalDate.parse(dateStart);
            const jsDate = convert(dateStart).toDate();
            let options = {
                weekday: 'long',
            };
            const dayName = jsDate.toLocaleDateString(window.locale, options);
            options = {
                day: 'numeric',
                month: 'long',
            };
            const monthAndDayName = jsDate.toLocaleDateString(window.locale, options);

            // let slotDate = self.slot
            //     ? window.moment(self.slot.date, ['YYYY-MM-DD']).format('DD-MM-YYYY')
            //     : null;
            //
            // if (self.slot && self.slot.repeated_settings && slotDate == self.form.date_start) {
            //     dateStart = window.moment(self.slot.repeated_settings.repeated_on_date, [
            //         'DD-MM-YYYY',
            //         'YYYY-MM-DD',
            //     ]);
            // } else {
            //     dateStart = window.moment(self.form.date_start, ['DD-MM-YYYY', 'YYYY-MM-DD']);
            // }

            const weeks = {
                1: trans('first'),
                2: trans('second'),
                3: trans('third'),
                4: trans('fourth'),
                5: trans('fifth'),
                6: trans('sixth'),
                7: trans('seventh'),
                8: trans('eighth'),
                9: trans('ninth'),
                10: trans('tenth'),
                11: trans('eleventh'),
                12: trans('twelfth'),
                13: trans('thirteenth'),
                14: trans('fourteenth'),
            };

            const weekN = Math.ceil(dateStart.dayOfMonth() / 7);
            const weekNumber = weeks[weekN] ? weeks[weekN] : '';
            const quarterWeek = Math.ceil(dateStart.get(IsoFields.DAY_OF_QUARTER) / 7);
            const quarterWeekName = weeks[quarterWeek] ? weeks[quarterWeek] : '';

            return [
                {
                    id: 1,
                    label: trans('Daily'),
                },
                {
                    id: 2,
                    label: trans('Weekly on') + ' ' + dayName,
                },
                {
                    id: 3,
                    label: trans('Monthly on the') + ' ' + weekNumber + ' ' + dayName,
                },
                {
                    id: 5,
                    label: trans('Quarterly on the') + ' ' + quarterWeekName + ' ' + dayName,
                },
                {
                    id: 4,
                    label: trans('Annually on') + ' ' + monthAndDayName,
                },
                {
                    id: 6,
                    label: trans('Custom...'),
                },
            ];
        },
        optionsOnListMonth() {
            let dateStart = this.dateStart;
            dateStart = LocalDate.parse(dateStart);
            const jsDate = convert(dateStart).toDate();
            let options = {
                weekday: 'long',
            };
            const dayName = jsDate.toLocaleDateString(window.locale, options);

            // let slotDate = self.slot
            //     ? window.moment(self.slot.date, ['YYYY-MM-DD']).format('DD-MM-YYYY')
            //     : null;
            //
            // if (self.slot && self.slot.repeated_settings && slotDate == self.form.date_start) {
            //     dateStart = window.moment(self.slot.repeated_settings.repeated_on_date, [
            //         'DD-MM-YYYY',
            //         'YYYY-MM-DD',
            //     ]);
            // } else {
            //     dateStart = window.moment(self.form.date_start, ['DD-MM-YYYY', 'YYYY-MM-DD']);
            // }

            const weeks = {
                1: trans('first'),
                2: trans('second'),
                3: trans('third'),
                4: trans('fourth'),
                5: trans('fifth'),
            };

            const weekN = Math.ceil(dateStart.dayOfMonth() / 7);
            const weekNumber = weeks[weekN] ? weeks[weekN] : '';

            return [
                {
                    id: 1,
                    label: trans('Monthly on day') + ' ' + dateStart.dayOfMonth(),
                },
                {
                    id: 2,
                    label: trans('Monthly on the') + ' ' + weekNumber + ' ' + dayName,
                },
            ];
        },
    },
    methods: {
        emitValues() {
            this.$emit('update:modelValue', {
                repeatRangeType: this.repeatRangeType,
                repeatUntil: this.repeatUntil,
                repeatAfter: this.repeatAfter,
                repeatFrequency: this.repeatFrequency,
                repeatEvery: this.repeatEvery,
                repeatEveryType: this.repeatEveryType,
                repeatOn: this.repeatOn,
                repeatOnEveryMonth: this.repeatOnEveryMonth,
            });
        },
    },
    watch: {
        watchedFields() {
            this.emitValues();
        }
    }
};
</script>

<style scoped></style>
